/**
 * JSON met gesorteerde sleutels: twee objecten met dezelfde inhoud in een andere
 * volgorde geven dezelfde tekst. Velden met `undefined` vallen weg, net als bij
 * `JSON.stringify` (een body die over de lijn gaat kent ze ook niet).
 *
 * Gedeeld door de ontwerp-hash (`vst-design-hash.ts`) en de sleutel van de
 * gedeelde prijsfetch (`shared-price-fetch.ts`). Geen imports: de configurator
 * (op alle producten) gebruikt het.
 */
export function stableJson(waarde: unknown): string {
  if (waarde === null || typeof waarde !== 'object') return JSON.stringify(waarde) ?? 'null';
  if (Array.isArray(waarde)) return `[${waarde.map(stableJson).join(',')}]`;
  const obj = waarde as Record<string, unknown>;
  const delen = Object.keys(obj)
    .filter((k) => obj[k] !== undefined)
    .sort()
    .map((k) => `${JSON.stringify(k)}:${stableJson(obj[k])}`);
  return `{${delen.join(',')}}`;
}
